const LANG_CODES = {
  DE: 'de-DE',
  EN: 'en-GB',
  FR: 'fr-FR',
  ES: 'es-ES',
  IT: 'it-IT',
  PT: 'pt-PT',
  NL: 'nl-NL',
};

export function speak(text, langCode) {
  if (!window.speechSynthesis) {
    console.warn('Web Speech API nicht unterstützt');
    return;
  }

  window.speechSynthesis.cancel();

  const lang = LANG_CODES[langCode?.toUpperCase()] || 'de-DE';
  const utterance = new SpeechSynthesisUtterance(text);
  utterance.lang = lang;
  utterance.rate = 0.9;
  utterance.pitch = 1;
  utterance.volume = 1;

  // Stimmen sind manchmal noch nicht geladen
  const voices = window.speechSynthesis.getVoices();

  if (voices.length === 0) {
    // Warten bis Stimmen geladen sind
    window.speechSynthesis.onvoiceschanged = () => {
      const loadedVoices = window.speechSynthesis.getVoices();
      const voice = loadedVoices.find(v => v.lang.startsWith(lang.split('-')[0]));
      if (voice) utterance.voice = voice;
      window.speechSynthesis.speak(utterance);
      window.speechSynthesis.onvoiceschanged = null;
    };
  } else {
    // Passende Stimme suchen
    const voice = voices.find(v => v.lang.startsWith(lang.split('-')[0]));
    if (voice) utterance.voice = voice;
    window.speechSynthesis.speak(utterance);
  }
}